<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
                <title>Github</title>
                <circle class="PermanentGithubRing" :id="'PermanentGithubRing' + id" cx="22.75" cy="22.75" r="22"/>
                <circle class="GithubRing" :id="'GithubRing' + id" cx="22.75" cy="22.75" r="22"/>
                <path class="GithubLogo" :id="'GithubLogo' + id" d="M13,25.3A12.37,12.37,0,0,0,21.2,37a.61.61,0,0,0,.8-.6V34.3c-3.3.7-4-1.6-4-1.6a3.17,3.17,0,0,0-1.3-1.8c-1.1-.8.1-.7.1-.7a2.47,2.47,0,0,1,1.8,1.3,2.51,2.51,0,0,0,3.5,1,2.23,2.23,0,0,1,.8-1.6c-2.7-.3-5.5-1.4-5.5-6.1a5.32,5.32,0,0,1,1.2-3.3,5.1,5.1,0,0,1,.1-3.3s1-.3,3.3,1.3a10.32,10.32,0,0,1,3-.4,10.32,10.32,0,0,1,3,.4c2.3-1.6,3.3-1.3,3.3-1.3a4.52,4.52,0,0,1,.1,3.3,4.79,4.79,0,0,1,1.2,3.3c0,4.7-2.8,5.8-5.5,6.1a3.1,3.1,0,0,1,.8,2.3v3.4a.61.61,0,0,0,.8.6,12.18,12.18,0,0,0,8.2-11.7A12.07,12.07,0,0,0,25,13,12.17,12.17,0,0,0,13,25.3Z" transform="translate(-2.25 -2.25)"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        link: String,
        darkMode: Boolean,
        id: Number
    },
    methods: {
        enter: function () {
            // document.getElementById("GithubRing" + this.id).style.stroke = "#ABABAB";
            // document.getElementById("GithubRing" + this.id).style.fill = "#000";

            document.getElementById("GithubLogo" + this.id).style.fill = "rgb(116, 166, 185)";
        },
        leave: function () {
            // document.getElementById("GithubRing" + this.id).style.stroke = this.darkMode ? "#000000" : "#FFFFFF";
            // document.getElementById("GithubRing" + this.id).style.fill = "none";
            
            document.getElementById("GithubLogo" + this.id).style.fill = this.darkMode ? "#000000" : "#FFFFFF";
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            document.getElementById("PermanentGithubRing" + this.id).style.stroke = "#FFFFFF";
            document.getElementById("GithubLogo" + this.id).style.fill = "#FFFFFF";
        }
    }
}
</script>

<style scoped>
#head {
    height: 45px;
    width: 45px;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
}
.PermanentGithubRing {
    fill: none;
    stroke-width: 1.5px;
    stroke: #000000;
}
a > svg > .GithubRing {
    fill: #000;
    opacity: 0;
    transition: opacity .2s linear;
}
svg:hover > .GithubRing {
    opacity : 1;
}
a > svg > .GithubLogo {
    fill-rule: evenodd;
    /* fill: #FFFFFF; */
    transition: fill .4s linear;
}
svg:hover > .GithubLogo {
    /* fill: #303030; */
}
/* .borderRectangle {
    fill: none;
} */
svg {
    width: 45px;
    position: absolute;
}
</style>